import { createLink } from '@tanstack/react-router'
import { AnchorHTMLAttributes, ComponentProps, type JSX, forwardRef } from 'react'

import { Button, Icon, buttonVariants, cn } from '@hap/components'

const BaseLinkButton = forwardRef<
  HTMLAnchorElement,
  AnchorHTMLAttributes<HTMLAnchorElement> & ComponentProps<typeof Button>
>(
  (
    {
      children,
      className,
      variant,
      size,
      icon,
      iconClassName,
      rounded,
      loading,
      loadingLabel = 'Please wait',
      ...props
    },
    ref,
  ): JSX.Element => {
    const isDisabled = props.disabled || loading

    return (
      <a
        {...props}
        className={cn(buttonVariants({ variant, size, rounded }), className, {
          'pointer-events-none opacity-50': isDisabled,
        })}
        ref={ref}
      >
        {loading ? (
          <>
            <Icon name="arrows-clockwise" className="mr-2 h-4 w-4 animate-spin" />
            {loadingLabel}
          </>
        ) : (
          <>
            {icon && (
              <Icon
                name={icon}
                className={cn(
                  { 'mr-2 -ml-2': size !== 'icon' && size !== 'icon-sm' },
                  iconClassName,
                )}
              />
            )}
            {children}
          </>
        )}
      </a>
    )
  },
)

export const LinkButtonHref = BaseLinkButton

export const LinkButton = createLink(BaseLinkButton)
